import React from "react";
import { Typography, Button } from "@mui/material";
import styles from "./AboutUs.module.css";
import HomeIcono from "../../components/HomeIcon/HomeIcono";

const AboutUs: React.FC = () => {

  // Secciones de la página
  const sections = [
    {
      title: "¡Nuestra historia!",
      content:
    `Durante varios años, se pensó y se oró sobre si era hora de comenzar una
congregación en la ciudad de Puebla. Y todo comenzó dando un paso de fe y
obediencia, a los Salamanca Marín Dios los estaba preparando para un cambio
drástico en su vida, porque los años de servir a Dios en otros ministerios
estaban llegando a su fin. En marzo de 2020, en plena pandemia y con las
restricciones a tope se celebró la primer reunión en casa únicamente con los 5
integrantes de la familia Salamanca. Semanas después se fueron presentando
amigos y conocidos que en la sala de la familia se reunían a estudiar y adorar a
el Eterno. En mayo del 2020 se estableció formalmente Colectivo Siete.`    },
     {
      title: "¡Vamos al Jardín!",
      content:
    `Dios abrió las puertas para que en medio de un tiempo de muchas restricciones
pudiéramos reunirnos en un espacio al aire libre, y nos proveyó que un jardín
prestado por un tiempo en el sur de la ciudad. Bajo un pequeño techo de
lámina realizábamos nuestros servicios, pero dado el crecimiento fue momento
de ocupar el resto de jardín, solo que ahora teníamos un inconveniente y era el
sol. Entonces entramos en una nueva etapa como Colectivo, fue el hecho de
realizar nuestras reuniones bajo un nuevo formato de “Autocinema” los sábados
por la noche. Fue maravilloso ver como las manos de hombres y mujeres
trabajaron para acondicionar ese jardín en un autocine totalmente funcional,
donde adorábamos con alabanza en vivo, y se proyectaba la enseñanza y
películas con motivos bíblicos, entre fogatas y raidolitos. Cabe destacar que en
este mismo periodo de tiempo se hizo un esfuerzo por promover el mensaje de
la palabra a través de grabaciones en diferentes localidades como Veracruz,
Tepito, Coyoacán, Barrio Chino, Bellas artes, y varios lugares emblemáticos.
`    },
     {
      title: "¡A la sombra del Eterno! ",
      content:
    `Después de estar en este formato de reuniones de sábado por la noche,
estábamos listos para una siguiente etapa. Con el apoyo de varias familias se
hizo el esfuerzo de comprar una malla sombra para dar el siguiente paso a
nuestras reuniones los domingos por la mañana en un jardín acogedor y
cubiertos por la presencia de Dios. Colectivo Siete siempre ha contado con
manos que se esfuerzan, en el jardín era necesario montar y habilitar cada
domingo los espacios para nuestras reuniones. Un equipo de alabanza que
descargaba y cargaba el equipo de audio e instrumentos, equipo de bienvenida
que montaba y desmontaba sillas, y el equipo de cafetería como siempre unos
guerreros entregando lo mejor, Maestros de niños en un salón rústico pero
siempre dando lo mejor a la nueva generación.
`    },
          {
      title: "¡Nueva Casa!",
      content:
    `Año y medio pasamos en el jardín donde vivimos momentos increíbles y
desafiantes, sin embargo era momento de dar el siguiente paso. Se comenzó a
buscar unas instalaciones con mayor funcionalidad y finalmente llegamos a este
lugar en Febrero del 2022 que era una fábrica pero que ahora iba a ser nuestra
nueva casa. Una vez más con el esfuerzo de muchas familias se adecuó este
lugar para dar la bienvenida a todas las personas que quieran buscar a el Eterno
con todo el corazón. Paso a paso se ha ido adaptando este lugar con el apoyo
de todas las familias que se congregan en Colectivo.
`    },    {
      title: "¡Lo que somos y lo que hacemos…! ",
      content:
    `Colectivo Siete, es una congregación de personas de diversos orígenes
espirituales y denominaciones, pero todos creemos que toda la Biblia, desde
Génesis hasta Apocalipsis, es para todo el pueblo de Dios. Honramos el
Shabat, observamos las fiestas bíblicas ( moedim ) y comemos bíblicamente
Kosher. Lo más importante es que creemos que Yeshúa (Jesús) es el Mesías de
Israel y el Salvador del mundo. Como Sus discípulos ( talmidim ), creemos que
el Dios de Abraham, Isaac y Jacob es el Único y Verdadero Dios y que Él está
llamando a Su pueblo a regresar a Él y a Sus caminos. Es por eso que nos
reunimos en Shabat y también el primer día de la semana para alabar, cantar,
danzar, estudiar y tener compañerismo.
`    },
       {
      title: "¡Esto creemos! ",
      content:
    `Si bien nos encanta utilizar oraciones, canciones y costumbres hebreas en
nuestra experiencia de adoración, no nos consideramos exclusivamente de
raíces mesiánicas o hebreas. Queremos que todos los miembros del Cuerpo de
Yeshúa se sientan bienvenidos, inspirados y desafiados en nuestros servicios,
así que no se sorprenda si escucha una canción de estilo hebreo seguida de un
himno clásico. En cada aspecto de la adoración, queremos que el Espíritu Santo
( Ruaj HaKodesh ) nos guíe para que el Padre esté complacido con nuestros
esfuerzos. Nuestro deseo es cultivar un ambiente que invite a la Presencia del
Todopoderoso a morar con nosotros y capacitarnos para caminar unidos a Él y
en unidad unos con otros. Es con el espíritu de “amar a Dios” y “amar a nuestro
prójimo” que hemos establecido Colectivo Siete.
`    },
{
      title: "¡Amar y Servir!",
      content:
    `Colectivo Siete se construye sobre los hombros de servidores que reunión a
reunión están dispuestos a amar a Dios y a amar a su prójimo. Gracias a que
ponen al servicio de Dios y de Colectivo sus dones, talentos, tiempo, dinero,
etc. Es que seguimos creciendo y extendiéndonos hacia ser lo que el Eterno
espera de nosotros como colectivo.
Colectivo Adoración, Ministerio de mujeres “Sublime”, Ministerio de hombres
“Aryeh”, Colectivo Kids, Club 7, Hello Colectivo, Equipo de Bienvenida, Equipo
de Comunicación, Administración, gracias a todos y cada uno que conforman el
cuerpo de servidores porque sin ellos no caminaríamos como Colectivo.
`    },
{
      title: "¡Nuestro Nombre!",
      content:
    `¿Por qué Colectivo? Porque “Colectivo” está relacionado un grupo de personas
que tienen un fin en común y que trabajan para un mismo propósito. Colectivo
lo hacemos todas las personas.
¿Por qué Siete ? De acuerdo a la numerología de la Biblia el “7” es el número de
Dios porque nos habla de su perfección, es como su firma. Es por ello que
vemos el número 7 en elementos, como los 7 días de la semana, 7 notas
musicales, 7 fiestas, etc.
¿Por qué la “Manita”?
El símbolo de la mano, representa la letra hebrea “Shin” que es la inicial en el
título de Dios “Shaddai” = “Todopoderoso”. Esta letra es la vigésima sexta del
alfabeto hebreo, simboliza el Poder Divino. En el pueblo de Israel los sacerdotes
cuando daban la bendición al pueblo ponían sus manos en esta forma
declarando “Adonai te bendiga y te guarde…” (Números 6:24)
¡Esperamos que puedas ser parte de esta experiencia! 
`    },
 
  ];

  const valores = [
    {
        title: "1. Solo Palabra (perseveraban en la doctrina)",
    },
     {
        title: "2. Un Común Denominador (estaban juntos y tenían todo en común)",
    },
     {
        title: "3. Jesús el pan de vida (partimiento del pan)",
    },
     {
        title: "4. La oración nuestra comunicación (en la oración)",
    },
     {
        title: "5. Expresión de Gratitud (alababan a Dios)",
    },
     {
        title: "6. Somos sal y Luz (Disfrutaban de la estimación del pueblo)",
    },
     {
        title: "7. Crecimiento Saludable (Dios añadía cada día a la gente)",
    },

 
  ]


  return (<div className={styles.mainAbout}>
        <HomeIcono></HomeIcono>
        <div className={styles.container}>
      <div className={styles.center}>
        {/* Título principal */}
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 43,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 5,
            color: "black"
          }}
        >
          ¿QUIÉNES SOMOS?
        </Typography>
        {/* Secciones */}
        {sections.map((section) => (
          <div key={section.title}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: 16,
                lineHeight: 1.2,
                fontWeight: 900,
                            boxShadow: "10px 7px black",
            border: "black 2px solid"
              }}
            >
              {section.title}
            </Typography>

            <p className={styles.textAbout}>{section.content}</p>
          </div>
        ))}
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 43,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 2,
          }}
        >
          VISIÓN
        </Typography>
        {/* Botón de nuestro codigo */}
          <Typography
          variant="h2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 16,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 5,
            boxShadow: "10px 10px black",
            border: "black 2px solid"
          }}
        >
          La visión de Colectivo Siete la encontramos en la palabra en Hechos 2:42-47 y
          se divide en 7 partes
        </Typography>
          {valores.map((section) => (
          <div key={section.title}>
            <p className={styles.textAbout} >{section.title}</p>
          </div>
        ))}
       
       <div>

       <Typography
          variant="h2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 43,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 2,
          }}
        >
          VALORES
        </Typography>

         <Typography
          variant="h2"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 16,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 2,
            boxShadow: "10px 10px black",
            border: "black 2px solid"
          }}
        >
           Los Valores que mueven a Colectivo Siete son 7
        </Typography>

        <button className={styles.valoresBtn}>
          1. SABIDURÍA (Eclesiastés 10:10, 1 Corintios 3:10)
        </button>
        
        <button className={styles.valoresBtn}>
          2. HUMILDAD (Salmos 127:1, 1 Corintios 3:6-9)
        </button>

        <button  className={styles.valoresBtn}>
             3. FIDELIDAD (Mateo 25:23)
        </button>

       <button className={styles.valoresBtn}>
                 4. COMPASIÓN (Mateo 9:36)
        </button>

        <button className={styles.valoresBtn}>
        5. FE (Salmos 119:32)
        </button>

        <button className={styles.valoresBtn}>
         6. GENEROSIDAD (2 Corintios 9:11)
        </button>

        <button  className={styles.valoresBtn}>
          7. SERVICIO ( Romanos 12:11)
        </button>
       </div>
          

      
       
       
        
      </div>
    </div>
  </div>
   
  );
};

export default AboutUs;
